import React, {useState} from "react";
import "./chooseCriteriaOrScoreCard.scss";
import {Radio, Checkbox, FormControlLabel} from "@mui/material";
import AddCriteriaModal from "./AddCriteriaModal/AddCriteriaModal";
import Checkboxes from "../../../../Checkboxes/Checkboxes";

const ChooseCriteriaOrScoreCard = ({onSelectCriteria, selectedCriteria, onScoreCardNameChange,
                                       scoreCardName, onCreateScoreCard, scoreCards, selectedScoreCardId,
                                       onSelectStoryCard, criteriasAvailable, onCreateCriteria, isLoading:isCallScoreLoading}) => {

    const [showCreateCriteriaModal, setShowCreateCriteriaModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('')

    // const handleCheckboxChange = (event) => {
    //     const { name, checked } = event.target;
    //     onSelectCriteria(name, checked)
    // };

    const handleScoreCardNameChange = (e) => {
        const text = e.target.value;
        onScoreCardNameChange(text);
    }

    const handleStoryCardSelect = (event) => {
        const { name, checked } = event.target;
        onSelectStoryCard(name, checked)
    };

    const handleAddCriteriaClick = () => {
        openCreateCriteriaModal();
    }

    const openCreateCriteriaModal = () => {
        setShowCreateCriteriaModal(true)
    }
    const closeCreateCriteriaModal = () => {
        setShowCreateCriteriaModal(false)
    }

    const handleCreateScorecard = async () => {
        try {
            setIsLoading(true)
            setErrorMessage('')
            await onCreateScoreCard()
        } catch (error) {
            console.log('Create scorecard failed', error)
            setErrorMessage(error && error.message)
        } finally {
            setIsLoading(false)
        }
    }

    const disableCreateScoreCardButton = selectedCriteria.length === 0 || !scoreCardName || isLoading;

return <div className={"build-score-card-container"}>
        <div className={"cards-container"}>
        {
            scoreCards.map(({name, id, criteriaNames = []}) => {
                return (
                    <div key={id} className={`story-card ${id === selectedScoreCardId ? 'selected' : ''}`}>
                        <FormControlLabel
                            key={id}
                            value="start"
                            control={<Radio style ={{color: "#0075FF"}} onClick={handleStoryCardSelect} checked={id === selectedScoreCardId}/>}
                            label={name}
                            name={id}
                            labelPlacement="start"
                        />
                        {criteriaNames.map(criteriaName => {
                            return <div className='score-card-content'>{criteriaName}</div>
                        })}
                    </div>
                )
            })
        }
        </div>
        <p className={"sub-text"}>Build your scorecard:</p>
        {errorMessage && <div className='error-message'>{errorMessage}</div>}
        <div className={"score-card-header"}>
            <input type="text" placeholder="Name your score card"
                   className={"scorecard-input"}
                   value={scoreCardName}
                   required onChange={handleScoreCardNameChange}
                   disabled={isCallScoreLoading}
            />
            <button onClick={handleCreateScorecard}
                    className={`blue-button create-score-card-button ${ disableCreateScoreCardButton ? 'button-disabled' : ''}`}
                    disabled={disableCreateScoreCardButton}
            >
                {isLoading ? <div className="loading-spinner"></div> : 'Create Scorecard'}
            </button>
        </div>
        <Checkboxes optionsAvailable={criteriasAvailable} onCheckboxClick={onSelectCriteria} selectedIds={selectedCriteria}
        showCustomButton={true} customButtonName={"Create Custom Criteria"} onCustomButtonClick={handleAddCriteriaClick}
        maxSelections={3} isLoading={isCallScoreLoading} disableCustomButton={isCallScoreLoading}
                    showModal={true} modalTitle={"View Criteria"}
        />
        <AddCriteriaModal show={showCreateCriteriaModal} closeModal={closeCreateCriteriaModal} onCreateCriteria={onCreateCriteria} />
    </div>
}

export default ChooseCriteriaOrScoreCard